import {
  SAVE_SECTION_PATH,
  HYDRATE_FROM_LOCAL_STORE,
  CLEAR_SECTION_PATH,
  LOGOUT_COMPLETE,
  END_IMPERSONATION,
} from 'js/constants/actionTypes';

export interface SectionNavigationState {
  [key: string]: string;
}

const initialState: SectionNavigationState = {};

export const sectionNavigationReducer = (
  state: SectionNavigationState = initialState,
  action: any,
): SectionNavigationState => {
  switch (action.type) {
    case HYDRATE_FROM_LOCAL_STORE:
      return {
        ...state,
        ...(action.sectionNavigation || {}),
      };

    case SAVE_SECTION_PATH:
      return {
        ...state,
        [action.payload.section]: action.payload.path,
      };

    case CLEAR_SECTION_PATH:
      const newState = { ...state };
      delete newState[action.payload.section];
      return newState;

    case LOGOUT_COMPLETE:
    case END_IMPERSONATION:
      return initialState;

    default:
      return state;
  }
};
